import { IComponentOptions } from "angular";
import { IEnrichedTeam, ITeam } from "@gtmhub/teams";
import { IAssignee } from "@gtmhub/assignees";
import { StateService } from "@uirouter/angularjs";

export interface IBaseTeamProfileInfoBindings {
  team: IEnrichedTeam;
  focusSelectManagerField: boolean;
  updateField(params: { field: keyof ITeam; value: string | string[] }): void;
}

export interface BaseTeamProfileInfoCtrl extends IBaseTeamProfileInfoBindings {
  // initial data for the respective user-selectors
  managerId: string[];
  parentId: string[];
}

export class BaseTeamProfileInfoCtrl {
  static $inject = ["$state"];

  constructor(private $state: StateService) {}

  $onInit(): void {
    if (this.team.manager) {
      this.managerId = [this.team.manager];
    }

    if (this.team.parentId) {
      this.parentId = [this.team.parentId];
    }
  }

  public updateManagerId(id: string) {
    if (id !== this.team.manager) {
      this.managerId = id ? [id] : [];
      this.updateField({ field: "manager", value: id });
    }
  }

  public updateParentId(id: string) {
    if (id !== this.team.parentId) {
      this.parentId = id ? [id] : [];
      this.updateField({ field: "parentId", value: id });
    }
  }

  public updateTeamMembers(memberIds: string[]): void {
    const oldMemberIds = new Set(this.team.members);
    const valueChange = oldMemberIds.size !== memberIds.length || !memberIds.every((id) => oldMemberIds.has(id));

    if (valueChange) {
      this.updateField({ field: "members", value: memberIds });
    }
  }

  public navigateToProfile(assignee: IAssignee) {
    if (assignee) {
      const goToUrl = assignee.type === "user" ? ".employee" : "gtmhub.teams.team";
      const goToUrlParamProp = assignee.type === "user" ? "employeeId" : "teamId";

      this.$state.go(goToUrl, { [goToUrlParamProp]: assignee.id });
    }
  }
}

export const BaseTeamProfileInfoComponent: IComponentOptions = {
  controller: BaseTeamProfileInfoCtrl,
  bindings: {
    team: "<",
    focusSelectManagerField: "<?",
    updateField: "&",
  },
  templateUrl: require("./base-team-info.component.html"),
};
